import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import React, { useState } from 'react';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { utility } from '../../utility';

/** MyMine Version2.0 Notification機能追加
 * NotificationManagement List Table Component
 */
const NotificationManagementListTable = ({ controlSettings, screenSettings, messageList, notificationManagedPage, iconControlList, setModalInfo }) => {

  const [currentHoverNotificationId, setCurrentHoverNotificationId] = useState(null);

  return (
    <Box sx={{ height: 730, border: '1px solid rgb(224, 224, 224)' }}>
      {/* データ無し時：データ無しメッセージ / データ有り時：Notification一覧 */}
      {notificationManagedPage.ItemList.length === 0
        ? <MyMLabel className='d-flex justify-content-center'>{messageList.MyM_MSG_I_0059}</MyMLabel>
        :
        <TableContainer sx={{ height: '100%' }}>
          <Table>
            <TableBody sx={{
              'tr > td': { paddingTop: 1 },
              'tr:nth-of-type(2n) > td': { paddingBottom: 1 },
              'tr:nth-of-type(2n-1) > td': { paddingBottom: 0 },
            }} >
              {notificationManagedPage.ItemList.map((notificationItem) => (
                <React.Fragment key={notificationItem.NotificationId}>
                  <NotificationManagementListTableRow isHover={notificationItem.NotificationId === currentHoverNotificationId} setCurrentHoverNotificationId={setCurrentHoverNotificationId} setModalInfo={setModalInfo} notificationItem={notificationItem}>
                    <TableCell className='border-bottom-0' colSpan={2} scope='row' width='90%'>
                      <MyMLabel fontWeight='bold'>{utility.convertEllipsisFormat(notificationItem.Title, screenSettings.MaxDispNotificationTitleCharCount)}</MyMLabel>
                    </TableCell>
                    <TableCell className='pt-0' rowSpan={2} scope='row' width='10%'>
                      {notificationItem.IsExpired ? iconControlList.expired.control('large') : iconControlList.published.control('large')}
                    </TableCell>
                  </NotificationManagementListTableRow>
                  <NotificationManagementListTableRow isHover={notificationItem.NotificationId === currentHoverNotificationId} setCurrentHoverNotificationId={setCurrentHoverNotificationId} setModalInfo={setModalInfo} notificationItem={notificationItem}>
                    <TableCell>
                      <MyMLabel>{controlSettings.LabelList.lblDurationTitle}{utility.formatDate(notificationItem.DurationFrom)} ～ {utility.formatDate(notificationItem.DurationTo)}</MyMLabel></TableCell>
                    <TableCell>
                      <MyMLabel>{controlSettings.LabelList.lblUpdateDateTitle}{utility.formatDate(notificationItem.UpdateDate)}</MyMLabel>
                    </TableCell>
                  </NotificationManagementListTableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
    </Box>
  );
}
export default NotificationManagementListTable;

/**
 * NotificationManagement List Table Row Component
 */
const NotificationManagementListTableRow = React.memo(({ isHover, setCurrentHoverNotificationId, setModalInfo, notificationItem, children }) => {
  return (
    <TableRow
      onMouseEnter={() => setCurrentHoverNotificationId(notificationItem.NotificationId)}
      onMouseLeave={() => setCurrentHoverNotificationId(null)}
      sx={{ backgroundColor: isHover && 'rgba(0, 0, 0, 0.04)' }}
      onDoubleClick={() => setModalInfo({ isOpen: true, notificationId: notificationItem.NotificationId })}
    >
      {children}
    </TableRow>
  );
})
